module.exports = __webpack_public_path__ + "img/scroll-icon-2.07781b8e.png";